import { render, staticRenderFns } from "./FormulateInputUrl.vue?vue&type=template&id=af8018a6&"
import script from "./FormulateInputUrl.vue?vue&type=script&lang=js&"
export * from "./FormulateInputUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports